<template>
  <v-container fluid class="pa-0">
    <v-container fluid class="pa-0 fill-height">
      <v-row no-gutters :justify="$vuetify.breakpoint.mobile?'center':'start'" align="center">
        <v-col cols="12" sm="6" class="mt-1" align-self="center">
          <v-img src="~@/assets/banner-transparent.png" contain class="mb-16 ma-auto ml-sm-2" max-width="80vw"/>
        </v-col>
      </v-row>
      <v-dialog
          v-model="dialog"
          max-width="450"
          persistent
          transition="dialog-bottom-transition"
      >
        <v-card dark elevation="10" shaped>
          <v-card-title class="headline pg-color-very-dark-pink">
            Une petite vérification...
          </v-card-title>
          <v-card-text class="pg-color-black headline" style="min-height: 300px">
            <v-img dark src="~@/assets/auth/popup-18-black.png" class="text-center">
              <v-row justify="center" align-content="center" align="center" class="fill-height">
                <v-col>J’affirme avoir plus de 18 ans. Je comprends que l'accès à cette application est strictement
                  réservé à un public majeur.
                </v-col>
              </v-row>
            </v-img>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                class="pg-color-deep-red"
                text
                @click="handleDisagree18Plus"
            >
              Abandonner
            </v-btn>
            <v-btn
                class="pg-color-deep-red"
                text
                @click="handleAccept18Plus"
            >Poursuivre
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row justify="center" no-gutters class="pt-sm-2 pt-12 pb-sm-2 pb-12" align="center">
        <v-col cols="11" sm="6" class=" pa-0 pa-md-12">
          <v-form ref="form_subscribe" v-model="validForm">
            <v-text-field
                v-model="nickName"
                :counter="255"
                :rules="nameRules"
                label="Pseudonyme"
                outlined
                dark
                class="pg-text-field pg-color-black-input-transparent white--text"
                required
            ></v-text-field>
            <v-text-field
                v-model="email"
                :rules="[rules.required, rules.email]"
                label="E-mail"
                class="pg-text-field pg-color-black-input-transparent"
                dark
                outlined
                required
            />
            <v-text-field
                v-model="password"
                dark
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min,passwordConfirmationRule]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Votre mot de passe"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
                class="pg-text-field pg-color-black-input-transparent"
                outlined
                required
            />
            <v-text-field
                v-model="passwordConfirm"
                dark
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min, passwordConfirmationRule]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Confirmer votre mot de passe"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
                class="pg-text-field pg-color-black-input-transparent"
                outlined
                required
            />
            <v-btn class="pg-color-white" block :disabled="loading || !validForm" @click="handleRegister">Créer un
              compte
              <v-progress-circular
                  indeterminate
                  color="purple"
                  class="ml-1"
                  v-if="loading"
              ></v-progress-circular>
            </v-btn>
          </v-form>
          <v-row class="mt-12" no-gutters>
            <v-col lg="6" offset-lg="3" class="white--text">
              Vous avez déjà un compte ? <br> Connectez vous en
              <v-btn dark :to="{name:'Login'}">cliquant ici !</v-btn>
            </v-col>
          </v-row>
          <v-alert
              :type=messageType
              dismissible
              v-model="showAlert"
          >{{ message }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import AuthPlayerMixin from "@/mixins/AuthPlayerMixin";
import MessageMixin from "@/mixins/MessageMixin";

export default {
  name: "Register",
  mixins: [AuthPlayerMixin, MessageMixin],
  data() {
    return {
      nickName: '',
      dialog: true,
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 255) || 'Name must be less than 255 characters',
      ],
    }
  },
  methods: {
    handleAccept18Plus() {
      this.dialog = false;
    },
    handleDisagree18Plus() {
      this.dialog = false;
      this.$router.push({name: 'Home'});
    },
    handleRegister() {
      this.loading = true;
      if (this.email && this.password) {
        this.$store.dispatch('auth/register', {
          email: this.email.trim(),
          plainPassword: this.password,
          firstName: 'Prénom',
          lastName: 'Nom',
          nickName: this.nickName
        }).then(
            () => {
              this.loading = false;
              this.showSuccessMessage('Inscription validée, merci de vérifier vos mails pour la finalisation');
              this.$router.push({name: "Login"})
            }).catch(
            error => {
              this.loading = false;
              console.error(error.response)
              this.message =
                  (error.response && error.response.data) ||
                  error.message ||
                  error.toString();
              if (error.response.status) {
                switch (error.response.status) {
                  case 400: {
                    this.message = "Le login et le mot de passe sont incorrects";
                  }
                    break;
                  case 401: {
                    this.message = "Ce pseudonyme est déjà pris.";
                  }
                    break;
                  default:
                    this.message = "Une erreur est arrivée, merci de renouveller votre demande plus tard."
                }
              } else {
                this.message = "Une erreur est arrivée, merci de renouveller votre demande plus tard."
              }
              this.showErrorMessage(this.message);
            });
      } else {
        this.loading = false;
        this.showErrorMessage("Il faut rentrer le mail et le mot de passe");
      }
    }
  },
  watch: {
    'email': function () {
      this.email = this.email.toLowerCase().trim();
    }
  }
}
</script>

<style scoped>

</style>